import { guc } from '../services/Localisation';
import { checkMobileAndTabletBrowser, path } from '../utils';
import { store } from '../main';
import view from '../Enums';

export const selfOnboardingEnabled = () => guc('self_onboarding_enabled', false) || hmsSelfOnboardingEnabled();

export const earningPotentialEnabled = () => guc('earning_potential_enabled', false);

export const isLifeEnabled = () => guc('is_life_enabled', false);

export const hmsSelfOnboardingEnabled = () => path(store.getState(), 'globalReducer.hms_self_onboarding_enabled', false) && checkMobileAndTabletBrowser();
